import { WORKOUT_KEY } from '../../../../../modules/workout/model/constants/key'
import getPlannedAtWorkoutUtil from '../../../../../modules/workout/model/utils/get-planned-at'
import getDateAgendaUiSelect from '../../../../agenda-ui/selectors/get-date'
import { getIdReduxUtil } from '../../../../redux/utils/get-id'
import cloneWorkoutAction from '../clone'
import cloneAndSetWorkoutAction from '../clone-and-set'
import getByIdWorkoutSelector from '../../selectors/get-by-id'
import getCurrentWorkoutSelect from '../../selectors/get-current'
import { logUtil } from 'packages/src'
import canEditByIdWorkoutSelector from '../../selectors/can-edit-by-id'

export default function cloneIfCantEditWorkoutAction (params = {}) {
  return async (dispatch, getState) => {
    const workout = (
      params.workout ||
      getByIdWorkoutSelector(params.id)(getState()) ||
      getCurrentWorkoutSelect(getState())
    )

    const id = getIdReduxUtil(workout)
    if (canEditByIdWorkoutSelector(id)(getState())) {
      logUtil('cloneIfCantEditWorkoutAction')
        .debug(`[${id}][noop] can edit`)
      return workout
    }

    // If it is planned, set the new planned date to the current date
    const plannedAt = getPlannedAtWorkoutUtil(workout)
    let data
    if (plannedAt) {
      data = {
        [WORKOUT_KEY.PLANNED_AT]: getDateAgendaUiSelect(getState())
      }
    }

    if (params.cloneOnly) {
      logUtil('cloneIfCantEditWorkoutAction')
        .debug(`[${id}][start] clone only, data: `, data)
      return dispatch(cloneWorkoutAction({
        workout,
        data,
        keysToOmit: [
          WORKOUT_KEY.RECOMMENDED_AT,
          WORKOUT_KEY.PLAN_ID
        ]
      }))
    }

    logUtil('cloneIfCantEditWorkoutAction')
      .debug(`[${id}][start] clone and set, data: `, data)
    return dispatch(cloneAndSetWorkoutAction({
      workout,
      data,
      keysToOmit: [
        WORKOUT_KEY.RECOMMENDED_AT,
        WORKOUT_KEY.PLAN_ID
      ]
    }))
  }
}
